import DataRoomNodeCurrentLocation from './DataRoomNodeCurrentLocation.component';

export default DataRoomNodeCurrentLocation;
